import type { LogEntry } from '@mimir/primitive/structuredLogger';

/** Arrives as a JSON string or already parsed, depending on the CEP event path. */
export function parseBridgeLogEntry(data: unknown): LogEntry {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as LogEntry;
    } catch (_) {
      return { message: data };
    }
  }
  if (data !== null && typeof data === 'object') {
    return { ...(data as LogEntry) };
  }
  return { message: String(data) };
}
